var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect } from 'react';
import ChartBox from './cart-box';
import { capitalizeWords } from '../utils/formaters';
import { chart_height, initialMesutments, pdf_chart_height, pdf_width, print_height, print_width } from '../consts';
import _ from 'lodash';
import moment from 'moment';
import { useWindowSize } from '../hooks/useOnResize';
import { convertConfigurationsToBooleans } from '../utils/general-utils';
import { t } from '../multi-language/multi-lang.service';
function MonthlyCharts(_a) {
    var _b;
    var chartsData = _a.chartsData, configurations = _a.configurations, user = _a.user, isPdf = _a.isPdf;
    var width = useWindowSize()[0];
    var thresholdsStatus = (_b = configurations === null || configurations === void 0 ? void 0 : configurations.alerts) === null || _b === void 0 ? void 0 : _b.thresholds;
    configurations = convertConfigurationsToBooleans(configurations);
    useEffect(function () {
        drawCharts();
    }, [width]);
    var meaurments = initialMesutments(user);
    var units = _.mapValues(meaurments, function (_a) {
        var unit = _a.unit;
        return unit;
    });
    var thresholds = user.thresholds;
    var drawCharts = function () {
        var _a, _b;
        var daysInMonth = ((_b = (_a = chartsData[0]) === null || _a === void 0 ? void 0 : _a.data[0]) === null || _b === void 0 ? void 0 : _b.length) || 30;
        var dynamic_pdf_width = pdf_width - ((30 - daysInMonth) * 30); //smaller charts for smaller month 
        var width = isPdf ? dynamic_pdf_width : window.innerWidth - (window.innerWidth / 15);
        var height = isPdf ? pdf_chart_height : chart_height;
        chartsData.forEach(function (chart) {
            var draw = chart.draw, data = chart.data, type = chart.type;
            if (!configurations[type.replace('-', '_').toLowerCase()])
                return;
            var unitName = capitalizeWords(type.replace('_', ' '));
            var chartSVG = draw.apply(void 0, __spreadArray(__spreadArray([t], data, false), [thresholds,
                function (date) { return window.open("/static/reports/daily-report/".concat(moment(date).format('YYYY-MM-DD')), "_blank"); },
                chart.width || width,
                height,
                units[unitName],
                thresholdsStatus], false));
            var wrapCharts = document.createElement('div');
            var wrapBrowserChart = document.createElement('div');
            wrapBrowserChart.setAttribute('class', "".concat(!isPdf ? 'print-hide' : '', " pdf-cut-guard"));
            wrapBrowserChart.appendChild(chartSVG);
            wrapCharts.appendChild(wrapBrowserChart);
            // draw the same chart beat smaller for printing in portal
            if (!isPdf) {
                var chartSVGPrint = draw.apply(void 0, __spreadArray(__spreadArray([t], data, false), [thresholds,
                    function (date) { return window.open("/static/reports/daily-report/".concat(moment(date).format('YYYY-MM-DD')), "_blank"); },
                    print_width,
                    print_height,
                    units[unitName],
                    thresholdsStatus], false));
                var wrapPrintChart = document.createElement('div');
                wrapPrintChart.setAttribute('class', 'print-show pdf-cut-guard');
                wrapPrintChart.appendChild(chartSVGPrint);
                wrapCharts.appendChild(wrapPrintChart);
            }
            var chartNode = document.getElementsByClassName("".concat(type, "-chart"))[0];
            if (chartNode.hasChildNodes()) {
                chartNode.replaceChild(wrapCharts, chartNode.childNodes[0]);
            }
            else {
                chartNode.appendChild(wrapCharts);
            }
        });
    };
    return (React.createElement("div", { className: "wrap-charts" }, chartsData.map(function (chart) { return React.createElement(ChartBox, { key: chart.type, type: chart.type, configurations: configurations, isPdf: isPdf }); })));
}
export default MonthlyCharts;
//# sourceMappingURL=monthly-charts.js.map